import { formatToCstTime } from 'utils/time/formatToCstTime';

export const withinCallCenterHours = (localDate = new Date()) => {
	const cstTime = formatToCstTime(localDate);
	const day = cstTime.getDay();
	const hours = cstTime.getHours();
	const minutes = cstTime.getMinutes();
	// the call center is opened for the same hours during the week
	// and slightly different hours on the weekend
	switch (day) {
		case 0: // Sunday
			return hours >= 8 && hours < 19;
		case 6: // Saturday
			return hours >= 7 && hours < 20;
		default: // Mon-Fri
			// eslint-disable-next-line no-mixed-operators
			return (hours > 6 || (hours === 6 && minutes >= 30)) && hours < 23;
	}
};
